import { useMemo, useState } from 'react'
import { KpiStatRow } from '@/components/dashboard/KpiStatRow'
import { InterventionsChart } from '@/components/dashboard/InterventionsChart'
import { JobsByCategoryDonut } from '@/components/dashboard/JobsByCategoryDonut'
import {
  CompletedInterventionsRate,
  QuoteSignOffRate,
} from '@/components/dashboard/RatePanels'
import { PendingTasksPanel } from '@/components/dashboard/PendingTasksPanel'
import { ContractsToRenewPanel } from '@/components/dashboard/ContractsToRenewPanel'
import { TechnicianActivityTable } from '@/components/dashboard/TechnicianActivityTable'
import {
  DashboardPeriodContext,
  buildPeriodValue,
  currentPeriod,
} from '@/components/dashboard/DashboardPeriodContext'
import { MonthPicker } from '@/components/shared/MonthPicker'
import { useTopBarActions } from '@/contexts/TopBarActionsContext'
import { WelcomeSection } from '@/components/dashboard/WelcomeSection'

// Dashboard (2.2.x) — reproduces the dashboard.md Figma composition.
export default function DashboardPage() {
  // Selected month ("YYYY-MM"), default current month (feedback #2).
  const [period, setPeriod] = useState<string>(() => currentPeriod())
  const periodValue = useMemo(() => buildPeriodValue(period), [period])

  // Month picker lives in the TopBar actions slot on this route only.
  const monthPicker = useMemo(
    () => <MonthPicker value={period} onChange={setPeriod} />,
    [period]
  )
  useTopBarActions(monthPicker)

  return (
    <DashboardPeriodContext.Provider value={periodValue}>
      <div className='space-y-6'>
        <WelcomeSection />

        {/* KPI stat row */}
        <KpiStatRow />

        {/* Row 1: interventions bar chart + category donut (2-up, Figma) */}
        <div className='grid grid-cols-1 gap-6 lg:grid-cols-2'>
          <InterventionsChart />
          <JobsByCategoryDonut />
        </div>

        {/* Row 2: the two rate gauges side by side */}
        <div className='grid grid-cols-1 gap-6 lg:grid-cols-2'>
          <QuoteSignOffRate />
          <CompletedInterventionsRate />
        </div>

        {/* Row 3: pending tasks + contracts to renew */}
        <div className='grid grid-cols-1 gap-6 lg:grid-cols-2'>
          <PendingTasksPanel />
          <ContractsToRenewPanel />
        </div>

        {/* Technician activity table (full width) */}
        <TechnicianActivityTable />
      </div>
    </DashboardPeriodContext.Provider>
  )
}
